<template>
    <div class="bid-private" v-if="checkStateProduct == 'STATE_PREBID' || (checkStateProduct == 'STATE_PREBID_END' && checkAvailableTime)">
        <div class="block-bid">
            <div class="block-sm">
                <div class="block-current-price">
                    <div class="current-price">
                        <div class="top">
                            <div class="price">
                                <span class="number">{{ formatPrice(amountBidTop) }}</span>
                                <span class="text">JPY</span>
                            </div>
                            <div class="tax-fee">
                                <span class="text">消費税手数料込</span>
                                <span class="number">{{ formatPrice(amountBidTop * 1.21) }} JPY</span>
                            </div>
                        </div>
                    </div>
                    <div class="sold-out" v-if="bidTop && bidTop.amount > product.price_lowest_winning">売り切り</div>
                    <div class="tag">現在価格</div>
                    <div class="triangle"></div>
                </div>
                <div class="block-noti">
                    <div class="text-updated"
                         v-if="checkBidTop == 'type1'">
                        <i class="icon fas fa-exclamation-circle"></i>
                        <span>現在価格であなたがTOP入札中</span>
                    </div>
                    <div class="text-updated"
                         v-else-if="checkBidTop == 'type2'">
                        <i class="icon fas fa-exclamation-circle"></i>
                        <span>現在価格で入札中 最低価格に達していません</span>
                    </div>
                    <div class="text-updated" v-else-if="checkBidTop == 'type3' && this.bidTop">
                        <i class="icon fas fa-exclamation-circle"></i>
                        <span>あなたより他の会員が高値で入札しました</span>
                    </div>
                </div>
                <div class="block-enter-bid">
                    <div class="left">今すぐ入札する</div>
                </div>
                <div class="block-price-bid">
                    <div class="block-top">
                        <div class="block-input">
                            <input type="text" class="input-bid" :id="`input-${product.id}`" name="bid_incognito"
                                   :placeholder="bidTop ? bidTop.amount / 1000 : 0" @input="validateNumberInput()">
                            <div class="thousand">,000 <span class="jpy">JPY</span></div>
                        </div>
                    </div>
                    <div :id="`errors-price-${product.id}`" class="error d-none">現在価格より大きい価格を入力してください。</div>
                    <div id="" class="error d-none">現在価格より大きい価格を入力してください。</div>
                    <div class="block-bottom">
                        <button class="btn-send-price btn-large" @click="storeBidFavorite">入札する</button>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <div class="bid-private" v-else-if="(checkStateProduct == 'STATE_PREBID_END' && !checkAvailableTime) || checkStateProduct == 'OTHER' || checkStateProduct == 'AUCTION_STATE_STARTED'">
        <div class="block-bid">
            <div class="block-sm">
                <div class="block-current-price pd-top-0">
                    <div class="current-price">
                        <div class="top">
                            <div class="price">
                                <span class="number">{{ formatPrice(amountBidTop) }}</span>
                                <span class="text">JPY</span>
                            </div>
                            <div class="tax-fee">
                                <span class="text">消費税手数料込</span>
                                <span class="number">{{ formatPrice(amountBidTop * 1.21) }} JPY</span>
                            </div>
                        </div>
                    </div>
                    <div class="tag bg-brown">最終入札価格</div>
                    <div class="triangle triangle-brown"></div>
                </div>
                <div class="block-enter-bid bd-bottom">
                    <div class="left">あなたの入札価格</div>
                </div>
                <div class="block-price-bid">
                    <div class="block-my-amount">
                        <div class="amount">
                            {{ formatPrice(amountMyBidTop) }}<span class="jpy">JPY</span><span class="text">で入札中</span>
                        </div>
                        <div class="text-noti">消費税手数料込 {{ formatPrice(amountMyBidTop * 1.21) }} JPY</div>
                    </div>
                    <div class="block-bottom">
                        <button class="btn-send-price btn-large bg-gray">事前入札終了</button>
                        <div class="text-note">最終的な落札結果はLIVEオークション終了後に決定されます</div>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <div class="bid-private" v-else-if="checkStateProduct == 'NOT_WON_BID'">
        <div class="block-bid">
            <div class="block-sm">
                <div class="block-current-price pd-top-0">
                    <div class="current-price">
                        <div class="top">
                            <div class="price">
                                <span class="number">{{ formatPrice(amountBidEnd) }}</span>
                                <span class="text">JPY</span>
                            </div>
                            <div class="tax-fee">
                                <span class="text">消費税手数料込</span>
                                <span class="number">{{ formatPrice(amountBidEnd * 1.21) }} JPY</span>
                            </div>
                        </div>
                    </div>
                    <div class="tag bg-brown">最終入札価格</div>
                    <div class="triangle triangle-brown"></div>
                </div>
                <div class="block-enter-bid bd-bottom">
                    <div class="left">あなたの入札価格</div>
                </div>
                <div class="block-price-bid">
                    <div class="block-my-amount text-black">
                        <div class="amount text-black">
                            <span class="number">{{ formatPrice(amountMyBidTop) }}</span><span
                            class="jpy">JPY</span><span class="text">で入札中</span>
                        </div>
                        <div class="text-noti">消費税手数料込 {{ formatPrice(amountMyBidTop * 1.21) }} JPY</div>
                    </div>
                    <div class="block-bottom">
                        <button class="btn-send-price btn-large bg-gray">不成約</button>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <div class="bid-private" v-else-if="checkStateProduct == 'BID_FAIL'">
        <div class="block-bid">
            <div class="block-sm">
                <div class="block-current-price pd-top-0">
                    <div class="current-price">
                        <div class="top">
                            <div class="price">
                                <span class="number">{{ formatPrice(amountBidEnd) }}</span>
                                <span class="text">JPY</span>
                            </div>
                            <div class="tax-fee">
                                <span class="text">消費税手数料込</span>
                                <span class="number">{{ formatPrice(amountBidEnd) }} JPY</span>
                            </div>
                        </div>
                    </div>
                    <div class="tag bg-brown">最終入札価格</div>
                    <div class="triangle triangle-brown"></div>
                </div>
                <div class="block-enter-bid bd-bottom">
                    <div class="left">あなたの入札価格</div>
                </div>
                <div class="block-price-bid">
                    <div class="block-my-amount text-black">
                        <div class="amount text-black">
                            <span class="number">{{ formatPrice(amountMyBidTop) }}</span><span
                            class="jpy">JPY</span><span class="text">で入札中</span>
                        </div>
                        <div class="text-noti">消費税手数料込 {{ formatPrice(amountMyBidTop * 1.21) }} JPY</div>
                    </div>
                    <div class="block-bottom">
                        <button class="btn-send-price btn-large bg-gray">流札</button>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <div class="bid-private" v-else-if="checkStateProduct == 'WON_BID'">
        <div class="block-bid">
            <div class="block-sm">
                <div class="block-current-price pd-top-0">
                    <div class="current-price">
                        <div class="top">
                            <div class="price">
                                <span class="number">{{ formatPrice(amountBidEnd) }}</span>
                                <span class="text">JPY</span>
                            </div>
                            <div class="tax-fee">
                                <span class="text">消費税手数料込</span>
                                <span class="number">{{ formatPrice(amountBidEnd * 1.21) }} JPY</span>
                            </div>
                        </div>
                    </div>
                    <div class="tag bg-brown">最終入札価格</div>
                    <div class="triangle triangle-brown"></div>
                </div>
                <div class="block-enter-bid bd-bottom">
                    <div class="left">あなたの入札価格</div>
                </div>
                <div class="block-price-bid">
                    <div class="block-my-amount text-black">
                        <div class="amount text-black">
                            {{ formatPrice(amountMyBidTop) }}<span class="jpy">JPY</span><span class="text">で入札中</span>
                        </div>
                        <div class="text-noti">消費税手数料込 {{ formatPrice(amountMyBidTop * 1.21) }} JPY</div>
                    </div>
                    <div class="block-bottom">
                        <button class="btn-send-price btn-large bg-green">成約</button>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <div class="bid-private" v-else-if="checkStateProduct == 'BID_HOLD'">
        <div class="block-bid">
            <div class="block-sm">
                <div class="block-current-price pd-top-0">
                    <div class="current-price">
                        <div class="top">
                            <div class="price">
                                <span class="number">{{ formatPrice(amountBidEnd) }}</span>
                                <span class="text">JPY</span>
                            </div>
                            <div class="tax-fee">
                                <span class="text">消費税手数料込</span>
                                <span class="number">{{ formatPrice(amountBidEnd * 1.21) }} JPY</span>
                            </div>
                        </div>
                    </div>
                    <div class="tag bg-brown">最終入札価格</div>
                    <div class="triangle triangle-brown"></div>
                </div>
                <div class="block-enter-bid bd-bottom">
                    <div class="left">あなたの入札価格</div>
                </div>
                <div class="block-price-bid">
                    <div class="block-my-amount text-black">
                        <div class="amount text-black">
                            <span class="number">{{ formatPrice(amountMyBidTop) }}</span><span
                            class="jpy">JPY</span><span class="text">で入札中</span>
                        </div>
                        <div class="text-noti">消費税手数料込 {{ formatPrice(amountMyBidTop * 1.21) }} JPY</div>
                    </div>
                    <div class="block-bottom">
                        <button class="btn-send-price btn-large bg-gray">流札</button>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import CONSTANTS from "../constants";
import moment from "moment-timezone";

export default {
    mounted() {

    },
    async created() {
        await this.getDataBid();

        if (this.checkStateProduct != 'STATE_PREBID') {
            await this.getDataMyBidTop();
        }

        Echo.channel('bid.pre_bid.' + this.auction.id + '.' + this.product.id)
            .listen('.bid.pre_bid.sent', (e) => {
                this.bidTop = e.bidTop;
                this.checkTagTop();
            });

        Echo.channel('bid.pre_bid.' + this.auction.id)
            .listen('.bid.pre_bid.start', (e) => {
                if (this.auction.id == e.auction.id) {
                    this.checkStateAuction = e.auction.state;
                    this.checkTagTop();
                }
            });

        Echo.channel('bid.pre_bid.' + this.auction.id)
            .listen('.bid.pre_bid.end', (e) => {
                if (this.auction.id == e.auction.id) {
                    this.checkStateAuction = e.auction.state;

                    if (this.checkStateAuction == 5) {
                        this.getDataMyBidTop()
                    }

                    this.checkTagTop();
                }
            });

        Echo.channel('auction.' + this.auction.id)
            .listen('.auction.end', (e) => {
                if (this.auction.id == e.auction.id) {
                    this.checkStateAuction = e.auction.state;

                    if (this.checkStateAuction == 8) {
                        this.getAuctionProduct()
                        this.getDataMyBidTop()
                    }

                    this.checkTagTop();
                }
            });

        Echo.channel('auction.' + this.auction.id)
            .listen('.auction.setting.product_end_time', (e) => {
                if (this.auction.id == e.auction.id) {
                    window.location.reload();
                }
            });
    },
    props: [
        'auction',
        'product',
        'product_auction',
        'member',
    ],
    data: function () {
        return {
            bidTop: null,
            bidEnd: null,
            myBidTop: null,
            checkStateAuction: this.auction.state,
            checkProductAuction: this.product_auction,
        }
    },
    methods: {
        async getDataBid() {
            await axios.post('/bid/get-data-bid-private', {
                auctionId: this.auction.id,
                productId: this.product.id,
            })
                .then(res => {
                    this.bidTop = res.data.bidTop;
                    if (res.data.bidEnd) {
                        this.bidEnd = res.data.bidEnd
                    }
                })
                .catch(error => {

                })
        },

        async getDataMyBidTop() {
            await axios.post('/bid/get-data-my-bid-top', {
                auctionId: this.auction.id,
                productId: this.product.id,
            })
                .then(res => {
                    this.myBidTop = res.data.myBidTop;
                })
                .catch(error => {

                })
        },

        async getAuctionProduct() {
            await axios.post('/bid/get-data-auction-product', {
                auctionId: this.auction.id,
                productId: this.product.id,
            })
                .then(res => {
                    this.checkProductAuction = res.data.auctionProduct;
                    if (res.data.bidEnd) {
                        this.bidEnd = res.data.bidEnd
                    }
                })
                .catch(error => {

                })
        },

        async storeBidFavorite() {
            if ((this.checkStateAuction == 4 || (this.checkStateAuction == 5 && this.checkAvailableTime)) &&
                this.checkBidPermission() == CONSTANTS.CAN_BID) {
                let amount = document.getElementById(`input-${this.product.id}`).value * 1;
                this.clearValue();

                if (!document.getElementById(`errors-price-${this.product.id}`).classList.contains('d-none')) {
                    document.getElementById(`errors-price-${this.product.id}`).classList.add('d-none')
                }

                if (this.bidTop) {
                    if (amount && this.bidTop && amount * 1000 > this.bidTop.amount) {
                        await axios.post('/bid/store-pre-bid', {
                            auctionId: this.auction.id,
                            productId: this.product.id,
                            amount: amount * 1000,
                        })
                            .then(response => {

                            })
                            .catch(error => {
                                if(error.response.status === 422) {
                                    alert('オークション期間は終了しました。');
                                    window.location.reload();
                                }
                            })
                    } else {
                        document.getElementById(`errors-price-${this.product.id}`).classList.remove('d-none');

                        setTimeout(() => {
                            document.getElementById(`errors-price-${this.product.id}`).classList.add('d-none');
                        }, 5000)
                    }
                } else {
                    if (amount) {
                        await axios.post('/bid/store-pre-bid', {
                            auctionId: this.auction.id,
                            productId: this.product.id,
                            amount: amount * 1000,
                        })
                            .then(response => {

                            })
                            .catch(error => {
                                if(error.response.status === 422) {
                                    alert('オークション期間は終了しました。');
                                    window.location.reload();
                                }
                            })
                    } else {
                        document.getElementById(`errors-price-${this.product.id}`).classList.remove('d-none');

                        setTimeout(() => {
                            document.getElementById(`errors-price-${this.product.id}`).classList.add('d-none');
                        }, 5000)
                    }
                }
            } else {
                switch (this.checkBidPermission()) {
                    case CONSTANTS.NOT_MEMBER:
                        document.getElementsByClassName('not-member')[0].classList.remove('d-none');
                        break;
                    case CONSTANTS.CAN_NOT_BID:
                        document.getElementsByClassName('can-not-bid')[0].classList.remove('d-none');
                        break;
                }
                document.getElementById(`input-${this.product.id}`).value = '';
            }
        },

        clearValue() {
            return document.getElementById(`input-${this.product.id}`).value = '';
        },

        formatPrice(price) {
            return price ? price.toLocaleString(undefined, {maximumFractionDigits: 0}) : 0;
        },

        hideErros(id) {
            document.getElementById(`errors-price-${id}`).classList.add('d-none');
        },

        validateNumberInput() {
            let inputElement = document.getElementById(`input-${this.product.id}`);
            let inputValue = inputElement.value;
            inputElement.value = inputValue.replace(/[^0-9]/g, '');
        },

        checkBidPermission() {
            if (this.member.status != 1) {
                return CONSTANTS.NOT_MEMBER;
            }

            return CONSTANTS.CAN_BID
        },

        checkTagTop() {
            let element = document.getElementById(`tag-top-${this.product.id}`);

            if (this.checkBidTop == 'type1' || this.checkBidTop == 'type2') {
                if (element.classList.contains('d-none')) {
                    element.classList.remove('d-none');
                }
            } else {
                if (!element.classList.contains('d-none')) {
                    element.classList.add('d-none');
                }
            }
        }
    },
    computed: {
        checkBidTop: function () {
            if (
                this.bidTop
                && this.bidTop.member_id == this.member.id
                && this.bidTop.amount >= this.product.price_lowest_winning
            ) {
                return 'type1'
            }

            if (
                this.bidTop
                && this.bidTop.member_id == this.member.id
                && this.bidTop.amount < this.product.price_lowest_winning
            ) {
                return 'type2'
            }

            if (
                this.bidTop
                && this.bidTop.member_id != this.member.id
            ) {
                return 'type3'
            }

            return null;
        },

        amountBidTop: function () {
            return this.bidTop ? this.bidTop.amount : 0
        },

        amountMyBidTop: function () {
            return this.myBidTop ? this.myBidTop.amount : 0
        },

        amountBidEnd: function () {
            return this.bidEnd ? this.bidEnd.amount : 0
        },

        checkAvailableTime: function () {
            if(this.checkProductAuction.end_bid_pre_bid_time !== null) {
                let productEndPreBid = moment(this.checkProductAuction.end_bid_pre_bid_time).format('YYYY-MM-DD HH:mm:ss');
                let auctionEndPreBid = moment(this.auction.prebid_end_time).format('YYYY-MM-DD HH:mm:ss');
                let auctionLiveTime = moment(this.auction.start_time).format('YYYY-MM-DD HH:mm:ss');
                let current = moment().tz('Asia/Tokyo').format('YYYY-MM-DD HH:mm:ss');
                if ((productEndPreBid > auctionEndPreBid) &&
                    ((current > auctionEndPreBid) && (current < auctionLiveTime)) &&
                    // (productEndPreBid < auctionLiveTime) &&
                    (productEndPreBid > current)) {
                    return true;
                }
            }

            return false;
        },

        checkStateProduct: function () {
            if (
                (this.auction.classification == 3 || this.auction.classification == 1)
                && this.checkStateAuction == 4
            ) {
                return 'STATE_PREBID'
            }

            if (
                (this.auction.classification == 3 || this.auction.classification == 1)
                && this.checkStateAuction == 5
            ) {
                return 'STATE_PREBID_END'
            }

            if (
                (this.auction.classification == 3 || this.auction.classification == 1)
                && this.checkStateAuction == 7
            ) {
                return 'AUCTION_STATE_STARTED'
            }

            if (
                (this.checkStateAuction == 8 || this.checkStateAuction == 5)
                && this.checkProductAuction
                && (this.checkProductAuction.state == 5 || this.checkProductAuction.state == 6)
                && this.checkProductAuction.member_id != this.member.id
            ) {
                return 'NOT_WON_BID'
            }

            if (
                (this.checkStateAuction == 8 || this.checkStateAuction == 5)
                && this.checkProductAuction
                && this.checkProductAuction.state == 9
            ) {
                return 'BID_FAIL'
            }

            if (
                (this.checkStateAuction == 8 || this.checkStateAuction == 5)
                && this.checkProductAuction
                && (this.checkProductAuction.state == 5 || this.checkProductAuction.state == 6)
                && this.checkProductAuction.member_id == this.member.id
            ) {
                return 'WON_BID'
            }

            if (
                (this.checkStateAuction == 8 || this.checkStateAuction == 5)
                && this.checkProductAuction
                && this.checkProductAuction.state == 4
            ) {
                return 'BID_HOLD'
            }

            return 'OTHER';
        }
    },
}
</script>
